import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import axios from 'axios';
import { NgxSpinnerService } from 'ngx-spinner';
import * as XLSX from 'xlsx';
import { BrdsqlService } from '../../services/brdsql.service';
@Component({
  selector: 'app-caneinperday',
  templateUrl: './caneinperday.component.html',
  styleUrls: ['./caneinperday.component.css']
})
export class CaneinperdayComponent implements OnInit, OnDestroy {

  @ViewChild('table') table: ElementRef;
  yearLabelTh: string | any;
  qsetup: any = [];

  constructor(
    private spinner: NgxSpinnerService,
    private brdsql: BrdsqlService,
  ) { }

  ngOnInit(): void {
    this.getYearActive();
    this.Loadcaneperday();
  }

  dataperday: any = [];
  sumdata: any = [];

  loader = false;
  Loadcaneperday() {
    this.loader = true;
    this.spinner.show()
    // let url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbbrr/cpc5152dairy';
    let url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/dbbrr/select_s_f_w_0?s=*&f=[dbPayment].[dbo].[cpc5152dairy]&w=1=1 ORDER BY REPORTDATE DESC';

    axios.get(url)
      .then(res => {
        this.loader = false;
        this.spinner.hide()
        let data = res.data
        this.dataperday = data;
        this.sumdata = [
          {
            'sum_cnt_fresh': (data.map((el: any) => { return parseFloat(el.cnt_fresh) })).reduce((a, b) => a + b, 0),
            'sum_wgt_fresh': (data.map((el: any) => { return parseFloat(el.wgt_fresh) })).reduce((a, b) => a + b, 0),
            'sum_avg_fresh': (data.reduce((sum, item) => sum + (item.avg_fresh || 0), 0) / data.filter(item => item.avg_fresh !== 0).length),
            'sum_cnt_fire': (data.map((el: any) => { return parseFloat(el.cnt_fire) })).reduce((a, b) => a + b, 0),
            'sum_wgt_fire': (data.map((el: any) => { return parseFloat(el.wgt_fire) })).reduce((a, b) => a + b, 0),
            'sum_avg_fire': (data.reduce((sum, item) => sum + (item.avg_fire || 0), 0) / data.filter(item => item.avg_fire !== 0).length),
            'sum_cnt_all': (data.map((el: any) => { return parseFloat(el.cnt_all) })).reduce((a, b) => a + b, 0),
            'sum_wgt_all': (data.map((el: any) => { return parseFloat(el.wgt_all) })).reduce((a, b) => a + b, 0),
            'sum_avg_all': (data.reduce((sum, item) => sum + (item.avg_all || 0), 0) / data.filter(item => item.avg_all !== null).length),
          }
        ];
        console.log('sumdata:', this.sumdata);
      })
      .catch(err => { throw err })
  }

  async getYearActive() {
    await this.brdsql.getYearActive()
      .subscribe((res: any) => {
        // console.log('res: ', res)
        if (res) {
          this.qsetup = res.recordset[0];
          this.yearLabelTh = this.qsetup.yearThUsed;
          this.yearLabelTh = this.addSlashInMiddle(this.yearLabelTh);
        }
      })
  }

  addSlashInMiddle = (input: string): string => {
    if (input.length !== 4) {
      throw new Error("Input must be a string with exactly 4 characters");
    }
    const part1 = input.slice(0, 2); // ตัดสองตัวแรก เช่น "67"
    const part2 = input.slice(2);    // ตัดสองตัวหลัง เช่น "68"
    return `${part1}/${part2}`; // รวมเป็น "67/68"
  };

  ExportExcel() {
    let date0 = new Date().toLocaleString('sv-SE', { year: "numeric", month: "2-digit", day: "2-digit" });
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'data_');
    console.log('date0:', date0);
    /* save to file */
    XLSX.writeFile(wb, `ยอดอ้อยรายวัน_${date0}.xlsx`);
  }

  calPercen(target: number, achieved: number): number {
    if (target == 0 || achieved == 0) {
      //throw new Error("เป้าหมายต้องไม่เท่ากับ 0");
      return 0;
    }
    else {
      const percentage = (achieved / target) * 100;
      return percentage; // คืนค่าที่มีทศนิยม 2 ตำแหน่ง
    }

  }


  FormatThai(date: any) {
    if (!date) return '';
    const result = new Date(date);
    let thaiformat = result.toLocaleDateString('th-TH', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      // hour:'2-digit',
      // minute:'2-digit',
      // second:'2-digit'
    });
    return thaiformat
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.dataperday = null;
    this.sumdata = null;
  }

}
